import axios from '@axios'

export default {
  obter: id => axios.get(`${process.env.VUE_APP_WCOND_API}/imagem/${id}`),
}
